<template>
  <div class="container pt-3">
    <h3 class="text-center">Component</h3>
    <div class="d-flex justify-content-center">
      <vp-multiselect
        :options="options"
        trackBy="id"
        label="value"
        :allowEmpty="allowEmpty"
        :title="title"
        :multiple="multiple"
        :placeholder="placeholder"
        :showPlaceholderIcon="showPlaceholderIcon"
        :isLoading="isLoading"
        :dropDownStyle="dropDownStyle"
        :errMsg="errMsg"
        :selectLabel="selectLabel"
        :deselectLabel="deselectLabel"
        :showLabels="showLabels"
        :showNoResults="showNoResults"
        :openDirection="openDirection"
        :backgroundColor="backgroundColor"
        :width="width"
        :disabled="disabled"
        :showOptionsBorder="showOptionsBorder"
        :noResultMessage="noResultMessage"
        v-model="multiselectModel"
        :initialValue="multiselectModel"
        @searchChange="onSearchChange"
      />
    </div>

    <div class="text-center mt-2 vp-color-black-1">
      v-model : {{ multiselectModel }}
    </div>

    <div class="vp-py-40">
      <h3 class="vp-font-weight-800 text-center">Props</h3>

      <div class="col-container">
        <div class="vp-col vp-border-black-1-2 rounded">
          <h5 class="vp-font-weight-700">#General props</h5>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">title</label>
            <div class="col-sm-8">
              <input class="form-control vp-width-200" v-model="title" />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Placeholder</label>
            <div class="col-sm-8">
              <input class="form-control vp-width-200" v-model="placeholder" />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label">showPlaceholderIcon</label>
            <div class="col-sm-8 vp-mt-minus-8">
              <vp-switch v-model="showPlaceholderIcon" />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label">allowEmpty</label>
            <div class="col-sm-8 vp-mt-minus-8">
              <vp-switch v-model="allowEmpty" />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label">multiple</label>
            <div class="col-sm-8 vp-mt-minus-8">
              <vp-switch v-model="multiple" />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label">disabled</label>
            <div class="col-sm-8 vp-mt-minus-8">
              <vp-switch v-model="disabled" />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label">isLoading</label>
            <div class="col-sm-8 vp-mt-minus-8">
              <vp-switch v-model="isLoading" />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label">showOptionsBorder</label>
            <div class="col-sm-8 vp-mt-minus-8">
              <vp-switch v-model="showOptionsBorder" />
            </div>
          </div>
        </div>
      </div>

      <!-- Main container -->
      <div class="col-container">
        <!-- start::Row one -->
        <!-- start::#Controls -->
        <div class="vp-col vp-border-black-1-2 rounded">
          <h5 class="vp-font-weight-700">#Controls</h5>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">width ({{ width }}px)</label>
            <div class="col-sm-8">
              <b-form-input
                id="range-1"
                v-model="width"
                type="range"
                min="300"
                max="700"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label">backgroundColor</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="backgroundColor" />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label">dropDownStyle</label>
            <div class="col-sm-8">
              <select v-model="dropDownStyle" class="custom-select" id="">
                <option value="absolute">absolute</option>
                <option value="relative">relative</option>
              </select>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label">openDirection</label>
            <div class="col-sm-8">
              <select
                v-model="openDirection"
                class="custom-select"
                id=""
                :disabled="dropDownStyle == 'relative'"
              >
                <option value="top">top</option>
                <option value="bottom">bottom</option>
              </select>
            </div>
          </div>
        </div>
        <!-- end::#Controls -->

        <!-- start::#Labels -->
        <div class="vp-col vp-border-black-1-2 rounded">
          <h5 class="vp-font-weight-700">#Labels</h5>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">showLabels</label>
            <div class="col-sm-8 vp-mt-minus-8">
              <vp-switch v-model="showLabels" />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label">selectLabel</label>
            <div class="col-sm-8">
              <input
                class="form-control"
                :placeholder="
                  !showLabels
                    ? 'showLabels must be enabled'
                    : 'ex. Select label'
                "
                v-model="selectLabel"
                :disabled="!showLabels"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label">deselectLabel</label>
            <div class="col-sm-8">
              <input
                class="form-control"
                :placeholder="
                  !showLabels
                    ? 'showLabels must be enabled'
                    : 'ex. Deselect label'
                "
                v-model="deselectLabel"
                :disabled="!showLabels"
              />
            </div>
          </div>
        </div>
        <!-- end::#Labels -->

        <!-- start::#No Result -->
        <div class="vp-col vp-border-black-1-2 rounded">
          <h5 class="vp-font-weight-700">#No result</h5>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">showNoResults</label>
            <div class="col-sm-8 vp-mt-minus-8">
              <vp-switch v-model="showNoResults" :initialValue="true" />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label">noResultMessage</label>
            <div class="col-sm-8">
              <input
                class="form-control"
                :placeholder="
                  !showNoResults
                    ? 'showNoResults must be enabled'
                    : 'ex. No results found..'
                "
                v-model="noResultMessage"
                :disabled="!showNoResults"
              />
            </div>
          </div>
        </div>
        <!-- end::#No Result -->

        <!-- start::#Err message -->
        <div class="vp-col vp-border-black-1-2 rounded">
          <h5 class="vp-font-weight-700">#Errors</h5>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">errMsg</label>
            <div class="col-sm-8">
              <input
                class="form-control"
                placeholder="Error message.."
                v-model="errMsg"
              />
            </div>
          </div>
        </div>
        <!-- end::#Err message -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      multiselectModel: { id: 1, value: "Option 1" },
      errMsg: "",
      options: [
        { id: 1, value: "Option 1" },
        { id: 2, value: "Option 2" },
        { id: 3, value: "Option 3" },
        { id: 4, value: "Option 4" },
      ],
      directions: ["bottom", "top", "left", "right"],
      title: "",
      dropDownStyle: "absolute",
      selectLabel: "",
      deselectLabel: "",
      openDirection: "bottom",
      backgroundColor: "",
      width: "461",
      noResultMessage: "",
      allowEmpty: false,
      multiple: false,
      showPlaceholderIcon: false,
      isLoading: false,
      showLabels: false,
      showNoResults: true,
      disabled: false,
      showOptionsBorder: false,
      placeholder: "",
    };
  },
  methods: {
    onSearchChange(ev) {
      console.log(ev);
    },
  },
};
</script>

<style scoped>
:disabled {
  background: #dcdad1 !important;
}
label,
h1,
h2,
h3,
h4,
h5 {
  color: black;
}
h5 {
  text-decoration: underline;
}
.col-container {
  display: table;
  width: 110%;
  border-spacing: 3px;
  margin-inline-start: -25px;
}
.vp-col {
  display: table-cell;
  padding: 5px;
}
</style>
